import Service from '@/models/Service'

export default class Staff {
  id: string
  name: string
  serviceItem: Service[]
  constructor (id: string, displayName: string, serviceItem: Service[]) {
    this.id = id
    this.name = displayName
    this.serviceItem = serviceItem
  }
}
